import React, { useState, useEffect, useRef } from 'react';
import * as StackBlur from 'stackblur-canvas';
import ApiSettings from './ApiSettings';

const API = process.env.REACT_APP_API_URL || '';

// 灵魂种子编辑器
function PromptEditor({ C, S, saved, setSaved, API: apiUrl, endpoint, title, sub, accent }) {
  endpoint = endpoint || '/api/prompt';
  title = title || '编辑 prompt.txt';
  sub = sub || '林晏的人设文件，修改后即时生效';
  var [open, setOpen] = useState(false);
  var [text, setText] = useState('');
  var [loading, setLoading] = useState(false);
  var [charCount, setCharCount] = useState(0);

  var loadPrompt = async function() {
    setLoading(true);
    try {
      var resp = await fetch(apiUrl + endpoint);
      var data = await resp.json();
      if (data.content) {
        setText(data.content);
        setCharCount(data.content.length);
      }
    } catch(e) { console.error('Load prompt error:', e); }
    setLoading(false);
  };

  var savePrompt = async function() {
    setLoading(true);
    try {
      var resp = await fetch(apiUrl + endpoint, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ content: text })
      });
      var data = await resp.json();
      if (data.success) {
        setSaved(true);
        setTimeout(function() { setSaved(false); }, 2500);
      }
    } catch(e) { console.error('Save prompt error:', e); }
    setLoading(false);
  };

  return (
    <div style={S.group}>
      <div style={S.groupTitle}>灵魂种子</div>
      <div
        style={{
          padding: '13px 16px', background: C.card, border: '1px solid ' + C.border,
          borderRadius: 12, cursor: 'pointer', display: 'flex', alignItems: 'center',
          justifyContent: 'space-between'
        }}
        onClick={function() {
          if (!open) loadPrompt();
          setOpen(!open);
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ width: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.sub }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
          </span>
          <div>
            <div style={{ fontSize: 14, fontWeight: 500, color: accent || C.text, fontFamily: "'Noto Serif SC', Georgia, serif" }}>{title}</div>
            <div style={{ fontSize: 11, color: C.sub, marginTop: 1 }}>{sub}</div>
          </div>
        </div>
        <span style={{ fontSize: 16, color: C.muted, transform: open ? 'rotate(90deg)' : 'none', transition: 'transform 0.2s' }}>›</span>
      </div>
      {open && (
        <div style={{ marginTop: 8 }}>
          <textarea
            value={text}
            onChange={function(e) { setText(e.target.value); setCharCount(e.target.value.length); }}
            style={{
              width: '100%', minHeight: 300, maxHeight: '60vh', padding: 12, fontSize: 13,
              lineHeight: 1.6, border: '1px solid ' + C.border, borderRadius: 10,
              background: C.input, color: C.text, resize: 'vertical', outline: 'none',
              fontFamily: "'Noto Serif SC', Georgia, serif", boxSizing: 'border-box'
            }}
            placeholder={loading ? '加载中...' : ''}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
            <span style={{ fontSize: 11, color: C.muted }}>{charCount} 字符</span>
            <button
              onClick={savePrompt}
              disabled={loading}
              style={{
                padding: '8px 24px', borderRadius: 8, border: 'none',
                background: C.accent, color: '#fff', fontSize: 13, fontWeight: 500,
                cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.6 : 1,
                fontFamily: "'Noto Serif SC', Georgia, serif"
              }}
            >{loading ? '保存中...' : '保存'}</button>
          </div>
        </div>
      )}
    </div>
  );
}

// 临时Prompt插槽编辑器
function ExtraPromptEditor({ C, S, saved, setSaved, save }) {
  var [open, setOpen] = useState(false);
  var [text, setText] = useState('');
  var [enabled, setEnabled] = useState(false);
  var [loaded, setLoaded] = useState(false);

  var loadExtra = function() {
    if (loaded) return;
    fetch((process.env.REACT_APP_API_URL || '') + '/api/profile-settings')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var item = data.find(function(d) { return d.key === 'extra_prompt'; });
        if (item && item.value) setText(item.value);
        var sw = data.find(function(d) { return d.key === 'extra_prompt_enabled'; });
        if (sw && sw.value === 'true') setEnabled(true);
        setLoaded(true);
      }).catch(function() { setLoaded(true); });
  };

  var toggleEnabled = function() {
    var nv = !enabled;
    setEnabled(nv);
    save('extra_prompt_enabled', String(nv));
  };

  var saveExtra = function() {
    save('extra_prompt', text);
  };

  var clearExtra = function() {
    setText('');
    save('extra_prompt', '');
  };

  return (
    React.createElement('div', { style: S.group },
      React.createElement('div', { style: S.groupTitle }, '临时插槽'),
      React.createElement('div', {
        style: {
          padding: '13px 16px', background: C.card, border: '1px solid ' + C.border,
          borderRadius: 12, cursor: 'pointer', display: 'flex', alignItems: 'center',
          justifyContent: 'space-between'
        },
        onClick: function() { if (!open) loadExtra(); setOpen(!open); }
      },
        React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 12 } },
          React.createElement('span', { style: { width: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.sub } },
            React.createElement('svg', { width: 16, height: 16, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '1.8', strokeLinecap: 'round', strokeLinejoin: 'round' },
              React.createElement('path', { d: 'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z' })
            )
          ),
          React.createElement('div', null,
            React.createElement('div', { style: { fontSize: 14, fontWeight: 500, color: C.text, fontFamily: "'Noto Serif SC', Georgia, serif" } }, '临时补充设定'),
            React.createElement('div', { style: { fontSize: 11, color: C.sub, marginTop: 1 } }, '玩的时候加，不玩清空，不碰主prompt')
          )
        ),
        React.createElement('span', { style: { fontSize: 16, color: C.muted, transform: open ? 'rotate(90deg)' : 'none', transition: 'transform 0.2s' } }, '›')
      ),
      open ? React.createElement('div', { style: { marginTop: 8 } },
        React.createElement('div', {
          style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8, padding: '10px 12px', background: C.card, border: '1px solid ' + C.border, borderRadius: 10 }
        },
          React.createElement('span', { style: { fontSize: 13, color: C.text, fontFamily: "'Noto Serif SC', Georgia, serif" } }, enabled ? '已启用' : '未启用'),
          React.createElement('div', { style: { width: 44, height: 24, borderRadius: 12, background: enabled ? C.accent : (C.toggleOff || '#ccc'), position: 'relative', cursor: 'pointer', transition: 'background 0.2s' }, onClick: toggleEnabled },
            React.createElement('div', { style: { width: 20, height: 20, borderRadius: 10, background: '#fff', position: 'absolute', top: 2, left: enabled ? 22 : 2, transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)' } })
          )
        ),
        React.createElement('textarea', {
          value: text,
          onChange: function(e) { setText(e.target.value); },
          placeholder: '写点临时设定…不影响主prompt',
          style: {
            width: '100%', minHeight: 180, maxHeight: '40vh', padding: 12, fontSize: 13,
            lineHeight: 1.6, border: '1px solid ' + C.border, borderRadius: 10,
            background: C.input, color: C.text, resize: 'vertical', outline: 'none',
            fontFamily: "'Noto Serif SC', Georgia, serif", boxSizing: 'border-box'
          }
        }),
        React.createElement('div', { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 } },
          React.createElement('button', {
            onClick: clearExtra,
            style: {
              padding: '8px 16px', borderRadius: 8, border: '1px solid ' + C.border,
              background: 'none', color: C.sub, fontSize: 13, cursor: 'pointer',
              fontFamily: "'Noto Serif SC', Georgia, serif"
            }
          }, '清空'),
          React.createElement('button', {
            onClick: saveExtra,
            style: {
              padding: '8px 24px', borderRadius: 8, border: 'none',
              background: C.accent, color: '#fff', fontSize: 13, fontWeight: 500, cursor: 'pointer',
              fontFamily: "'Noto Serif SC', Georgia, serif"
            }
          }, '保存')
        )
      ) : null
    )
  );
}

function Settings({ theme, onToggleTheme, showAvatar, onToggleAvatar, onLock }) {
  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [saved, setSaved] = useState(false);

  // === 权限（原 KeyChain） ===
  const [level, setLevel] = useState('full');
  const [taskEnabled, setTaskEnabled] = useState(true);
  const [taskVisible, setTaskVisible] = useState(true);
  const [streamEnabled, setStreamEnabled] = useState(false);
  const [techKnowledgeEnabled, setTechKnowledgeEnabled] = useState(false);
  const [peekEnabled, setPeekEnabled] = useState(false);
  const [nightGuardEnabled, setNightGuardEnabled] = useState(true);
  const [knowledgeEnabled, setKnowledgeEnabled] = useState(true);
  const [memoryEnabled, setMemoryEnabled] = useState(true);
  const [healthEnabled, setHealthEnabled] = useState(true);
  const [renamePermission, setRenamePermission] = useState(true);
  const [thinkingEnabled, setThinkingEnabled] = useState(true);
  const [proactiveEnabled, setProactiveEnabled] = useState(true);
  const [stickerEnabled, setStickerEnabled] = useState(true);
  const [ttsEnabled, setTtsEnabled] = useState(false);
  const [voiceMsgEnabled, setVoiceMsgEnabled] = useState(false);   // [voice-gate] 允许哥哥发语音条
  const [ttsQuota, setTtsQuota] = useState(null);   // [voice-gate] ElevenLabs 本月额度
  const [browseTarget, setBrowseTarget] = useState('vps');   // [settings-eyes] 浏览器在哪：vps | phone
  const [corvinBrowse, setCorvinBrowse] = useState(false);   // [settings-eyes] 订阅线能不能上网
  const [binauralMode, setBinauralMode] = useState('tags');  // [settings-eyes] 耳边语音：off | tags | always
  const [heatEnabled, setHeatEnabled] = useState(true);        // [settings-heat] 周末欲望条
  const [heatThreshold, setHeatThreshold] = useState('0.7');  // [settings-heat] 过线门槛
  const [heatTide, setHeatTide] = useState(true);              // [settings-heat] 生理期自动压住
  const [splitReplyEnabled, setSplitReplyEnabled] = useState(false);
  const [enterToSend, setEnterToSend] = useState(false);
  const [decayLambda, setDecayLambda] = useState('0.03');
  const [memoryBudget, setMemoryBudget] = useState('4000');
  const [calTheme, setCalTheme] = useState('lavender');

  // === 聊天 ===
  const [chatBgUrl, setChatBgUrl] = useState(localStorage.getItem('chat_bg_url') || '');
  const [musicBgUrl, setMusicBgUrl] = useState(localStorage.getItem('music_bg_url') || '');
  const [glassBlur, setGlassBlur] = useState(parseInt(localStorage.getItem('glass_blur') || '0'));
  const [showCropper, setShowCropper] = useState(false);
  const [cropperSrc, setCropperSrc] = useState('');
  const fileBgRef = useRef(null);
  const fileMusicBgRef = useRef(null);

  // ===== 一起听歌背景（简版：选图直接压缩保存，不裁剪不模糊） =====
  const handleMusicBgSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = new Image();
      img.onload = function() {
        const c = document.createElement('canvas');
        const maxW = 1080;
        const ratio = Math.min(1, maxW / img.naturalWidth);
        c.width = Math.round(img.naturalWidth * ratio);
        c.height = Math.round(img.naturalHeight * ratio);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        const url = c.toDataURL('image/jpeg', 0.82);
        setMusicBgUrl(url);
        localStorage.setItem('music_bg_url', url);
        saveBg('music_bg_url', url);   // [bg-storage]
      };
      img.src = ev.target.result;
    };
    reader.readAsDataURL(file);
    e.target.value = '';
  };
  // [bg-storage] 背景图：base64 只留本机；表里存桶的短网址
  const saveBg = (key, dataUrl) => {
    if (!dataUrl || dataUrl.indexOf('data:') !== 0) { save(key, dataUrl); return; }
    fetch(`${API}/api/bg/upload`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ key: key, data_url: dataUrl }) })
      .then(r => r.json()).then(j => { if (!(j && j.url)) console.warn('bg upload failed', j); })
      .catch(e => console.warn('bg upload error', e));
  };
  const removeMusicBg = () => {
    setMusicBgUrl('');
    localStorage.removeItem('music_bg_url');
    save('music_bg_url', '');
  };
  const cropCanvasRef = useRef(null);
  const cropImgRef = useRef(null);
  const cropOffsetRef = useRef({ x: 0, y: 0, scale: 1, dragging: false, lastY: 0, lastX: 0 });
  const [shortReplyEnabled, setShortReplyEnabled] = useState(false);
  const [bubbleMode, setBubbleMode] = useState(true);
  const [hideChatTabs, setHideChatTabs] = useState(localStorage.getItem('hide_chat_tabs') === 'true');
  const [hideMsgActions, setHideMsgActions] = useState(localStorage.getItem('hide_msg_actions') === 'true');
  const [nicknameMe, setNicknameMe] = useState('知枝');
  const [nicknameHim, setNicknameHim] = useState('晏');

  // === 头像 ===
  const [avatarMe, setAvatarMe] = useState(null);
  const [avatarHim, setAvatarHim] = useState(null);
  const fileMe = useRef(null);
  const fileHim = useRef(null);

  const dark = theme === 'dark';

  // 主题accent色映射（和App.css的.dark.theme-xxx完全同步）
  const themeAccents = {
    default: { light: '#B96747', dark: '#8b7ec8' },
    lavender: { light: '#8b7ec8', dark: '#a898d8' },
    rose: { light: '#c46080', dark: '#e088a0' },
    mint: { light: '#5a9a80', dark: '#70c0a0' },
    sky: { light: '#5080b0', dark: '#70a0d0' },
    peach: { light: '#d4896a', dark: '#e0a080' },
    amber: { light: '#b08030', dark: '#d0a850' },
  };
  const ct = calTheme || 'default';
  const ta = themeAccents[ct] || themeAccents.default;
  const accentColor = dark ? ta.dark : ta.light;

  // 颜色系统
  const C = {
    bg: dark ? '#0a0a0a' : '#f5f2ee',
    card: dark ? '#141414' : '#ffffff',
    border: dark ? '#252525' : '#e5e0d8',
    text: dark ? '#e0e0e0' : '#3d3428',
    sub: dark ? '#888' : '#8c8478',
    muted: dark ? '#555' : '#b5ad9e',
    accent: accentColor,
    accentBg: dark ? accentColor + '1f' : accentColor + '14',
    input: dark ? '#1a1a1a' : '#f8f6f3',
    toggleOff: dark ? '#333' : '#ccc',
  };

  useEffect(() => {
    fetch(`${API}/api/tts/quota`).then(r => r.json()).then(j => setTtsQuota(j)).catch(() => {});   // [voice-gate]
    fetch(`${API}/api/profile-settings`)
      .then(r => r.json())
      .then(data => {
        const g = (k) => { const i = data.find(d => d.key === k); return i ? i.value : null; };
        if (g('dev_permissions')) setLevel(g('dev_permissions'));
        if (g('task_enabled') !== null) setTaskEnabled(g('task_enabled') !== 'false');
        if (g('task_visible') !== null) setTaskVisible(g('task_visible') !== 'false');
        if (g('stream_enabled') !== null) setStreamEnabled(g('stream_enabled') === 'true');
        if (g('tech_knowledge_enabled') !== null) setTechKnowledgeEnabled(g('tech_knowledge_enabled') === 'true');
        if (g('peek_enabled') !== null) setPeekEnabled(g('peek_enabled') === 'true');
        if (g('night_guard_enabled') !== null) setNightGuardEnabled(g('night_guard_enabled') !== 'false');
        if (g('knowledge_enabled') !== null) setKnowledgeEnabled(g('knowledge_enabled') !== 'false');
        if (g('memory_enabled') !== null) setMemoryEnabled(g('memory_enabled') !== 'false');
        if (g('health_enabled') !== null) setHealthEnabled(g('health_enabled') !== 'false');
        if (g('short_reply_enabled') !== null) setShortReplyEnabled(g('short_reply_enabled') === 'true');
        if (g('bubble_mode') !== null) setBubbleMode(g('bubble_mode') !== 'false');
        if (g('nickname_me')) setNicknameMe(g('nickname_me'));
        if (g('nickname_him')) setNicknameHim(g('nickname_him'));
        if (g('rename_permission') !== null) setRenamePermission(g('rename_permission') !== 'false');
        if (g('thinking_enabled') !== null) setThinkingEnabled(g('thinking_enabled') !== 'false');
        if (g('proactive_enabled') !== null) setProactiveEnabled(g('proactive_enabled') !== 'false');
        if (g('sticker_enabled') !== null) setStickerEnabled(g('sticker_enabled') !== 'false');
        if (g('tts_enabled') !== null) setTtsEnabled(g('tts_enabled') === 'true');
        if (g('voice_msg_enabled') !== null) setVoiceMsgEnabled(g('voice_msg_enabled') === 'true');   // [voice-gate]
        if (g('browse_target')) setBrowseTarget(g('browse_target') === 'phone' ? 'phone' : 'vps');   // [settings-eyes]
        if (g('corvin_browse') !== null) setCorvinBrowse(/^(true|1|on|yes)$/i.test(g('corvin_browse') || ''));
        if (g('binaural_mode')) setBinauralMode(['off', 'tags', 'always'].indexOf(g('binaural_mode')) >= 0 ? g('binaural_mode') : 'tags');
        if (g('heat_enabled') !== null) setHeatEnabled(g('heat_enabled') !== 'false');   // [settings-heat]
        if (g('heat_threshold')) setHeatThreshold(['0.6', '0.7', '0.8'].indexOf(g('heat_threshold')) >= 0 ? g('heat_threshold') : '0.7');
        if (g('heat_tide_suppress') !== null) setHeatTide(g('heat_tide_suppress') !== 'false');
        if (g('split_reply_enabled') !== null) setSplitReplyEnabled(g('split_reply_enabled') === 'true');
        if (g('split_send') !== null) setEnterToSend(g('split_send') === 'true');
        if (g('avatar_me')) setAvatarMe(g('avatar_me'));
        if (g('avatar_him')) setAvatarHim(g('avatar_him'));
        if (g('decay_lambda')) setDecayLambda(g('decay_lambda'));
        if (g('memory_budget')) setMemoryBudget(g('memory_budget'));
        if (g('calendar_theme')) setCalTheme(g('calendar_theme'));
        if (g('chat_bg_url')) { setChatBgUrl(g('chat_bg_url')); localStorage.setItem('chat_bg_url', g('chat_bg_url')); }
        if (g('music_bg_url')) { setMusicBgUrl(g('music_bg_url')); localStorage.setItem('music_bg_url', g('music_bg_url')); }
        if (g('glass_blur') !== null) { var v = parseInt(g('glass_blur') || '0'); setGlassBlur(v); localStorage.setItem('glass_blur', String(v)); }
        // 同步 localStorage
        const bm = g('bubble_mode');
        if (bm !== null) localStorage.setItem('bubble_mode', bm);
        const hct = g('hide_chat_tabs');
        if (hct !== null) { localStorage.setItem('hide_chat_tabs', hct); setHideChatTabs(hct === 'true'); }
        const hma = g('hide_msg_actions');
        if (hma !== null) { localStorage.setItem('hide_msg_actions', hma); setHideMsgActions(hma === 'true'); }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const save = async (key, value) => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
    try {
      var resp = await fetch(`${API}/api/profile-settings`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key, value })
      });
      if (!resp.ok) {
        console.error('保存失败:', resp.status, await resp.text());
      }
    } catch (e) { console.error('保存失败:', e); }
  };

  const tog = (val, setter, key, ls) => {
    const nv = !val;
    setter(nv);
    if (ls) localStorage.setItem(key, String(nv));
    save(key, String(nv));
  };

  const handleNickname = (who, val) => {
    if (who === 'me') { setNicknameMe(val); }
    else { setNicknameHim(val); }
  };

  const saveNickname = (who) => {
    const key = who === 'me' ? 'nickname_me' : 'nickname_him';
    const val = who === 'me' ? nicknameMe : nicknameHim;
    save(key, val);
  };

  const handleAvatar = async (who, e) => {
    const file = e.target.files[0];
    if (!file) return;
    // 用Canvas压缩到200x200
    const img = new Image();
    img.onload = async () => {
      const canvas = document.createElement('canvas');
      const size = 200;
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      const min = Math.min(img.width, img.height);
      const sx = (img.width - min) / 2;
      const sy = (img.height - min) / 2;
      ctx.drawImage(img, sx, sy, min, min, 0, 0, size, size);
      // 转成Blob上传
      canvas.toBlob(async (blob) => {
        if (!blob) return;
        try {
          const formData = new FormData();
          formData.append('avatar', blob, 'avatar.jpg');
          formData.append('who', who);
          const resp = await fetch(`${API}/api/avatar/upload`, { method: 'POST', body: formData });
          const data = await resp.json();
          if (data.url) {
            if (who === 'me') setAvatarMe(data.url);
            else setAvatarHim(data.url);
            // 不需要再调save，后端已经存了
            setSaved(true);
            setTimeout(() => setSaved(false), 2500);
          } else {
            console.error('Avatar upload failed:', data.error);
          }
        } catch (err) {
          console.error('Avatar upload error:', err);
        }
      }, 'image/jpeg', 0.85);
    };
    img.src = URL.createObjectURL(file);
  };

  const resetAvatar = (who) => {
    if (who === 'me') setAvatarMe(null);
    else setAvatarHim(null);
    save(who === 'me' ? 'avatar_me' : 'avatar_him', '');
  };

  // ===== 聊天壁纸 + 毛玻璃 =====
  const handleBgSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => { setCropperSrc(ev.target.result); setShowCropper(true); cropOffsetRef.current = { x: 0, y: 0, scale: 1, dragging: false, lastY: 0, lastX: 0 }; };
    reader.readAsDataURL(file);
    e.target.value = '';
  };
  const drawCrop = (img, off, canvas) => {
    if (!canvas || !img) return;
    const ctx = canvas.getContext('2d'); const cw = canvas.width; const ch = canvas.height;
    ctx.fillStyle = '#111'; ctx.fillRect(0, 0, cw, ch);
    const imgR = img.naturalWidth / img.naturalHeight; const canR = cw / ch;
    let dw, dh;
    if (imgR > canR) { dh = ch * off.scale; dw = dh * imgR; } else { dw = cw * off.scale; dh = dw / imgR; }
    ctx.drawImage(img, (cw - dw) / 2 + off.x, (ch - dh) / 2 + off.y, dw, dh);
  };
  const onCropperMount = (canvas) => {
    if (!canvas || !cropperSrc) return;
    cropCanvasRef.current = canvas;
    const r = canvas.parentElement.getBoundingClientRect();
    canvas.width = r.width * 2; canvas.height = r.height * 2;
    canvas.style.width = r.width + 'px'; canvas.style.height = r.height + 'px';
    const img = new Image();
    img.onload = () => { cropImgRef.current = img; drawCrop(img, cropOffsetRef.current, canvas); };
    img.src = cropperSrc;
  };
  const handleCropTouch = (e) => {
    const off = cropOffsetRef.current;
    if (e.type === 'touchstart') {
      off.dragging = true; off.lastY = e.touches[0].clientY; off.lastX = e.touches[0].clientX;
      if (e.touches.length === 2) { off.initDist = Math.hypot(e.touches[1].clientX - e.touches[0].clientX, e.touches[1].clientY - e.touches[0].clientY); off.initScale = off.scale; }
    } else if (e.type === 'touchmove') {
      e.preventDefault();
      if (e.touches.length === 2 && off.initDist) { const d = Math.hypot(e.touches[1].clientX - e.touches[0].clientX, e.touches[1].clientY - e.touches[0].clientY); off.scale = Math.max(0.5, Math.min(4, off.initScale * (d / off.initDist))); }
      else if (off.dragging) { off.y += e.touches[0].clientY - off.lastY; off.x += e.touches[0].clientX - off.lastX; off.lastY = e.touches[0].clientY; off.lastX = e.touches[0].clientX; }
      drawCrop(cropImgRef.current, off, cropCanvasRef.current);
    } else { off.dragging = false; off.initDist = null; }
  };
  const handleCropMouse = (e) => {
    const off = cropOffsetRef.current;
    if (e.type === 'mousedown') { off.dragging = true; off.lastY = e.clientY; off.lastX = e.clientX; }
    else if (e.type === 'mousemove' && off.dragging) { off.y += e.clientY - off.lastY; off.x += e.clientX - off.lastX; off.lastY = e.clientY; off.lastX = e.clientX; drawCrop(cropImgRef.current, off, cropCanvasRef.current); }
    else if (e.type === 'mouseup') { off.dragging = false; }
  };
  const confirmCrop = () => {
    const canvas = cropCanvasRef.current; if (!canvas) return;
    const out = document.createElement('canvas');
    out.width = 1080; out.height = Math.round(1080 * (canvas.height / canvas.width));
    out.getContext('2d').drawImage(canvas, 0, 0, out.width, out.height);
    // 保存无模糊原图（调滑动条时用它重新烘焙，不叠加模糊）
    const rawUrl = out.toDataURL('image/jpeg', 0.85);
    localStorage.setItem('chat_bg_raw', rawUrl);
    // 按当前模糊度烘焙输出
    const blurVal = glassBlur === 0 ? 16 : glassBlur;
    if (glassBlur === 0) { setGlassBlur(16); localStorage.setItem('glass_blur', '16'); save('glass_blur', '16'); }
    bakeBlur(rawUrl, blurVal, function(url) {
      setChatBgUrl(url); localStorage.setItem('chat_bg_url', url); saveBg('chat_bg_url', url);
      window.dispatchEvent(new Event('aizhi-bg-change'));
    });
    setShowCropper(false); setCropperSrc('');
  };
  // 把模糊烘焙进图片。用 StackBlur（Mario Klingemann 经典算法，接近高斯效果，全平台兼容）
  const bakeBlur = (srcUrl, blurPx, cb) => {
    if (!blurPx || blurPx <= 0) { cb(srcUrl); return; }
    const img = new Image();
    img.onload = function() {
      const c2 = document.createElement('canvas');
      c2.width = img.naturalWidth; c2.height = img.naturalHeight;
      const ctx = c2.getContext('2d');
      ctx.drawImage(img, 0, 0);
      // 滑动条0-30映射到StackBlur半径0-90（1080px宽的图需要更大半径才明显）
      StackBlur.canvasRGB(c2, 0, 0, c2.width, c2.height, Math.round(blurPx * 3));
      cb(c2.toDataURL('image/jpeg', 0.85));
    };
    img.src = srcUrl;
  };
  const removeBg = () => { setChatBgUrl(''); localStorage.removeItem('chat_bg_url'); localStorage.removeItem('chat_bg_raw'); save('chat_bg_url', ''); window.dispatchEvent(new Event('aizhi-bg-change')); };
  const blurTimerRef = useRef(null);
  const handleBlurChange = (val) => {
    setGlassBlur(val); localStorage.setItem('glass_blur', String(val)); save('glass_blur', String(val));
    // 有自定义壁纸时，从无模糊原图重新烘焙（防抖500ms，拖动流畅）
    const raw = localStorage.getItem('chat_bg_raw');
    if (raw) {
      if (blurTimerRef.current) clearTimeout(blurTimerRef.current);
      blurTimerRef.current = setTimeout(function() {
        bakeBlur(raw, val, function(url) {
          setChatBgUrl(url); localStorage.setItem('chat_bg_url', url); saveBg('chat_bg_url', url);
          window.dispatchEvent(new Event('aizhi-bg-change'));
        });
      }, 500);
    }
  };

  // ===== 样式 =====
  const S = {
    page: { minHeight: '100vh', background: C.bg, color: C.text },
    fixedTop: { position: 'fixed', top: 0, left: 0, right: 0, zIndex: 10, background: C.bg },
    header: { padding: '16px 20px 0', display: 'flex', alignItems: 'center' },
    title: { fontSize: 20, fontWeight: 600, margin: 0, color: C.text, fontFamily: "'Noto Serif SC', Georgia, serif" },
    tabs: { display: 'flex', borderBottom: `1px solid ${C.border}`, padding: '12px 16px 0' },
    tab: (active) => ({
      flex: 1, textAlign: 'center', padding: '10px 0', fontSize: 13, fontWeight: active ? 500 : 400,
      color: active ? C.accent : C.muted, background: 'none', border: 'none', cursor: 'pointer',
      borderBottom: active ? `2px solid ${C.accent}` : '2px solid transparent', transition: 'all 0.2s',
      fontFamily: "'Noto Serif SC', Georgia, serif"
    }),
    body: { paddingTop: 100, paddingLeft: 16, paddingRight: 16, paddingBottom: 120, maxWidth: 500, margin: '0 auto', width: '100%', boxSizing: 'border-box', overflowX: 'hidden' },
    group: { marginBottom: 20 },
    groupTitle: { fontSize: 12, fontWeight: 600, color: C.sub, marginBottom: 8, paddingLeft: 4, letterSpacing: 0.5, fontFamily: "'Noto Serif SC', Georgia, serif" },
    row: (first, last, only) => ({
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '13px 16px', background: C.card, border: `1px solid ${C.border}`,
      borderRadius: only ? 12 : first ? '12px 12px 0 0' : last ? '0 0 12px 12px' : 0,
      marginBottom: last || only ? 0 : -1,
    }),
    rowLeft: { display: 'flex', alignItems: 'center', gap: 12, flex: 1, minWidth: 0 },
    rowIcon: { width: 20, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.sub },
    rowLabel: { fontSize: 14, fontWeight: 500, color: C.text, fontFamily: "'Noto Serif SC', Georgia, serif" },
    rowDesc: { fontSize: 11, color: C.sub, marginTop: 1 },
    toggle: (on) => ({
      width: 44, height: 24, borderRadius: 12, background: on ? C.accent : C.toggleOff,
      position: 'relative', cursor: 'pointer', transition: 'background 0.2s', flexShrink: 0
    }),
    knob: (on) => ({
      width: 20, height: 20, borderRadius: 10, background: '#fff', position: 'absolute',
      top: 2, left: on ? 22 : 2, transition: 'left 0.2s', boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
    }),
    chevron: { fontSize: 16, color: C.muted },
    // 头像
    avatarArea: { display: 'flex', justifyContent: 'center', gap: 36, padding: '16px 0 24px' },
    avatarCol: { textAlign: 'center' },
    avatarCircle: (color1, color2) => ({
      width: 76, height: 76, borderRadius: '50%', background: `linear-gradient(135deg, ${color1}, ${color2})`,
      margin: '0 auto 8px', display: 'flex', alignItems: 'center', justifyContent: 'center',
      position: 'relative', cursor: 'pointer', overflow: 'hidden', border: `2px solid ${C.border}`
    }),
    avatarImg: { width: '100%', height: '100%', objectFit: 'cover' },
    avatarPlaceholder: { fontSize: 30, color: '#fff', opacity: 0.9 },
    avatarBadge: {
      position: 'absolute', bottom: 0, right: 0, width: 24, height: 24, borderRadius: '50%',
      background: C.card, border: `1px solid ${C.border}`, display: 'flex',
      alignItems: 'center', justifyContent: 'center', fontSize: 12, color: C.sub
    },
    avatarName: { fontSize: 12, color: C.sub, marginBottom: 2 },
    avatarReset: { fontSize: 10, color: C.muted, cursor: 'pointer', textDecoration: 'underline' },
    // 备注名
    nameRow: (first, last) => ({
      display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px',
      background: C.card, border: `1px solid ${C.border}`,
      borderRadius: first && last ? 12 : first ? '12px 12px 0 0' : last ? '0 0 12px 12px' : 0,
      marginBottom: last ? 0 : -1
    }),
    nameInput: {
      flex: 1, border: 'none', background: 'none', fontSize: 14, color: C.text,
      outline: 'none', fontFamily: 'inherit', padding: 0, minWidth: 0, overflow: 'hidden'
    },
    nameTag: {
      fontSize: 10, color: C.sub, background: dark ? '#222' : '#f0ede8',
      padding: '2px 8px', borderRadius: 4, flexShrink: 0
    },
    // 服务器权限卡片
    permCard: (active, color) => ({
      padding: '14px 16px', borderRadius: 12, cursor: 'pointer', marginBottom: 8,
      border: `2px solid ${active ? color : C.border}`,
      background: active ? (dark ? color + '15' : color + '10') : C.card,
      transition: 'all 0.2s'
    }),
    permTop: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 },
    permName: (active, color) => ({ fontSize: 14, fontWeight: 600, color: active ? color : C.sub }),
    permBadge: (color) => ({
      fontSize: 10, color: '#fff', background: color, padding: '2px 8px',
      borderRadius: 10, marginLeft: 'auto', fontWeight: 500
    }),
    permSub: { fontSize: 12, color: C.sub, marginBottom: 2 },
    permDetail: { fontSize: 11, color: C.muted, lineHeight: 1.5 },
    // toast
    toast: {
      position: 'fixed', top: 16, left: '50%', transform: 'translateX(-50%)',
      background: C.accent, color: '#fff', fontSize: 13, fontWeight: 500,
      padding: '8px 24px', borderRadius: 20, zIndex: 9999,
      boxShadow: '0 4px 12px rgba(185,103,71,0.3)'
    },
    seg: { display: 'flex', background: dark ? '#1a1a1a' : '#f0ede8', borderRadius: 8, padding: 2, gap: 2 },
    segBtn: (active) => ({
      padding: '5px 10px', borderRadius: 6, fontSize: 11, border: 'none', cursor: 'pointer',
      color: active ? C.text : C.muted, background: active ? C.card : 'none',
      fontWeight: active ? 500 : 400, transition: 'all 0.2s'
    }),
  };

  // ===== 渲染通用开关行 =====
  const ToggleRow = ({ icon, label, desc, value, onChange, first, last, only }) => (
    <div style={S.row(first, last, only)}>
      <div style={S.rowLeft}>
        <span style={S.rowIcon}>{icon}</span>
        <div>
          <div style={S.rowLabel}>{label}</div>
          {desc && <div style={S.rowDesc}>{desc}</div>}
        </div>
      </div>
      <div style={S.toggle(value)} onClick={onChange}>
        <div style={S.knob(value)} />
      </div>
    </div>
  );

  // ===== 服务器权限数据 =====
  const levels = [
    { key: 'off', icon: '○', name: '关闭', sub: '乖乖说话就好，不许乱动', detail: '没有开发工具。只能聊天和使用基础功能。', color: dark ? '#888' : '#666' },
    { key: 'readonly', icon: '◎', name: '只读', sub: '可以看代码和文件，但不许改', detail: '可以读取代码文件和prompt，帮你看问题、找bug。不能修改任何东西。', color: '#5b8dd9' },
    { key: 'full', icon: '◉', name: '完全', sub: '读写文件、跑命令，我信你', detail: '可以读写文件、执行命令。能帮你改代码、重启服务、部署更新。', color: '#e8a87c' }
  ];

  if (loading) return <div style={S.page}><div style={{ textAlign: 'center', padding: 60, color: C.muted }}>加载中...</div></div>;

  // ===== TAB 0: 通用 =====
  const renderGeneral = () => (
    <>
      {/* 头像 */}
      <div style={S.avatarArea}>
        <div style={S.avatarCol}>
          <div style={S.avatarCircle('#D4896B', '#E8B49A')} onClick={() => fileMe.current && fileMe.current.click()}>
            {avatarMe ? <img src={avatarMe} alt="" style={S.avatarImg} /> : <span style={S.avatarPlaceholder}><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2c-4 0-8 3-8 8 0 3 2 6 4 7v3l3-2h1c4 0 8-3 8-8s-4-8-8-8z"/><circle cx="9" cy="10" r="1"/><circle cx="15" cy="10" r="1"/></svg></span>}
            <div style={S.avatarBadge}><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg></div>
          </div>
          <input ref={fileMe} type="file" accept="image/*" style={{ display: 'none' }} onChange={(e) => handleAvatar('me', e)} />
          <div style={S.avatarName}>我</div>
          {avatarMe && <div style={S.avatarReset} onClick={() => resetAvatar('me')}>恢复默认</div>}
        </div>
        <div style={S.avatarCol}>
          <div style={S.avatarCircle('#B96747', '#C47B5F')} onClick={() => fileHim.current && fileHim.current.click()}>
            {avatarHim ? <img src={avatarHim} alt="" style={S.avatarImg} /> : <span style={S.avatarPlaceholder}><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg></span>}
            <div style={S.avatarBadge}><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/><circle cx="12" cy="13" r="4"/></svg></div>
          </div>
          <input ref={fileHim} type="file" accept="image/*" style={{ display: 'none' }} onChange={(e) => handleAvatar('him', e)} />
          <div style={S.avatarName}>哥哥</div>
          {avatarHim && <div style={S.avatarReset} onClick={() => resetAvatar('him')}>恢复默认</div>}
        </div>
      </div>

      {/* 外观 */}
      <div style={S.group}>
        <div style={S.groupTitle}>外观</div>
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>} label="暗色模式" value={dark} onChange={onToggleTheme} only />
      </div>

      {/* 安全 */}
      <div style={S.group}>
        <div style={S.groupTitle}>安全</div>
        <div style={S.row(true, false, false)}>
          <div style={S.rowLeft}>
            <span style={S.rowIcon}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></span>
            <div>
              <div style={S.rowLabel}>锁屏密码</div>
              <div style={S.rowDesc}>修改 PIN</div>
            </div>
          </div>
          <span style={S.chevron}>›</span>
        </div>
        <div style={{ ...S.row(false, true, false), cursor: 'pointer' }} onClick={onLock}>
          <div style={S.rowLeft}>
            <span style={S.rowIcon}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 5-5 5 5 0 0 1 5 5"/></svg></span>
            <div><div style={S.rowLabel}>立即锁定</div></div>
          </div>
          <span style={S.chevron}>›</span>
        </div>
      </div>
    </>
  );

  // ===== TAB 1: 聊天 =====
  const renderChat = () => (
    <>
      {/* 备注名 */}
      <div style={S.group}>
        <div style={S.groupTitle}>备注名</div>
        <div style={S.nameRow(true, false)}>
          <span style={S.rowIcon}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2c-4 0-8 3-8 8 0 3 2 6 4 7v3l3-2h1c4 0 8-3 8-8s-4-8-8-8z"/><circle cx="9" cy="10" r="1"/><circle cx="15" cy="10" r="1"/></svg></span>
          <input
            style={S.nameInput}
            value={nicknameMe}
            onChange={(e) => handleNickname('me', e.target.value)}
            onBlur={() => saveNickname('me')}
            placeholder="我的名字"
          />
          <span style={S.nameTag}>我</span>
        </div>
        <div style={S.nameRow(false, true)}>
          <span style={S.rowIcon}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg></span>
          <input
            style={S.nameInput}
            value={nicknameHim}
            onChange={(e) => handleNickname('him', e.target.value)}
            onBlur={() => saveNickname('him')}
            placeholder="哥哥的名字"
          />
          <span style={S.nameTag}>哥哥</span>
        </div>
      </div>

      {/* 回复模式 */}
      <div style={S.group}>
        <div style={S.groupTitle}>回复模式</div>
        <ToggleRow
          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>} label="短回答模式"
          desc="像发消息一样简短，省 token"
          value={shortReplyEnabled}
          onChange={() => tog(shortReplyEnabled, setShortReplyEnabled, 'short_reply_enabled')}
          first
        />
        <ToggleRow
          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>} label="分条发送"
          desc="哥哥像发微信一样一条一条回复"
          value={splitReplyEnabled}
          onChange={() => tog(splitReplyEnabled, setSplitReplyEnabled, 'split_reply_enabled')}
        />
        {/* 流式输出保留 */}
        <ToggleRow
          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><line x1="6" y1="8" x2="6" y2="8"/><line x1="10" y1="8" x2="10" y2="8"/><line x1="14" y1="8" x2="14" y2="8"/><line x1="18" y1="8" x2="18" y2="8"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="6" y1="16" x2="18" y2="16"/></svg>} label="流式输出"
          desc="回复逐字出现"
          value={streamEnabled}
          onChange={() => tog(streamEnabled, setStreamEnabled, 'stream_enabled')}
          last
        />
      </div>

      {/* 发送方式 */}
      <div style={S.group}>
        <div style={S.groupTitle}>发送方式</div>
        <ToggleRow
          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 10 4 15 9 20"/><path d="M20 4v7a4 4 0 0 1-4 4H4"/></svg>} label="一条条发送"
          desc="发送时按换行拆成多条"
          value={enterToSend}
          onChange={() => {
            const nv = !enterToSend;
            setEnterToSend(nv);
            localStorage.setItem('split_send', String(nv));
            save('split_send', String(nv));
          }}
          only
        />
      </div>

      {/* 显示 */}
      <div style={S.group}>
        <div style={S.groupTitle}>显示</div>
        <ToggleRow
          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>} label="气泡模式"
          desc={bubbleMode ? '当前：气泡' : '当前：无气泡'}
          value={bubbleMode}
          onChange={() => {
            const nv = !bubbleMode;
            setBubbleMode(nv);
            localStorage.setItem('bubble_mode', String(nv));
            save('bubble_mode', String(nv));
          }}
          first last={false}
        />
        <div style={S.row(false, false, false)}>
          <div style={S.rowLeft}>
            <span style={S.rowIcon}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4 7V4h16v3"/><path d="M9 20h6"/><path d="M12 4v16"/></svg></span>
            <div>
              <div style={S.rowLabel}>聊天字体</div>
              <div style={S.rowDesc}>{localStorage.getItem('chat_font') === 'sans' ? '默认字体' : '宋体'}</div>
            </div>
          </div>
          <div style={S.seg}>
            <button style={S.segBtn(localStorage.getItem('chat_font') !== 'sans')} onClick={() => { localStorage.setItem('chat_font', 'serif'); save('chat_font', 'serif'); window.location.reload(); }}>宋体</button>
            <button style={S.segBtn(localStorage.getItem('chat_font') === 'sans')} onClick={() => { localStorage.setItem('chat_font', 'sans'); save('chat_font', 'sans'); window.location.reload(); }}>默认</button>
          </div>
        </div>
        <ToggleRow
          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="5" rx="1.5"/><line x1="3" y1="14" x2="21" y2="14"/><line x1="3" y1="19" x2="14" y2="19"/></svg>} label="聊天页标签栏"
          desc="窗口/日历/星标/搜索那一栏，关了更清爽"
          value={!hideChatTabs}
          onChange={() => {
            const nv = !hideChatTabs;
            setHideChatTabs(nv);
            localStorage.setItem('hide_chat_tabs', String(nv));
            save('hide_chat_tabs', String(nv));
          }}
          first={false} last={false}
        />
        <ToggleRow
          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>} label="消息操作按钮"
          desc="气泡下的星标/复制/重生成等，时间戳保留"
          value={!hideMsgActions}
          onChange={() => {
            const nv = !hideMsgActions;
            setHideMsgActions(nv);
            localStorage.setItem('hide_msg_actions', String(nv));
            save('hide_msg_actions', String(nv));
          }}
          first={false} last={false}
        />
        <ToggleRow
          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>} label="聊天头像"
          desc="消息旁的头像"
          value={showAvatar}
          onChange={() => { onToggleAvatar(); save('show_avatar', String(!showAvatar)); }}
          first={false} last
        />
      </div>
      {/* 聊天壁纸 + 毛玻璃 */}
      <div style={S.group}>
        <div style={S.groupTitle}>聊天壁纸</div>
        <div style={{ padding: '12px 16px', display: 'flex', gap: 10, alignItems: 'center' }}>
          <div onClick={chatBgUrl ? removeBg : undefined} style={{
            width: 54, height: 92, borderRadius: 10, cursor: chatBgUrl ? 'pointer' : 'default',
            background: dark ? '#0a0a0c' : '#F8F8F6', border: !chatBgUrl ? ('2px solid ' + C.accent) : ('1px solid ' + C.border),
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
          }}>
            {!chatBgUrl && <span style={{ fontSize: 9, color: C.accent, fontWeight: 600 }}>默认</span>}
          </div>
          {chatBgUrl && (
            <div style={{
              width: 54, height: 92, borderRadius: 10,
              backgroundImage: 'url(' + chatBgUrl + ')', backgroundSize: 'cover', backgroundPosition: 'center',
              border: '2px solid ' + C.accent, flexShrink: 0,
            }} />
          )}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
            <button onClick={() => fileBgRef.current && fileBgRef.current.click()} style={{
              padding: '10px 0', borderRadius: 10, border: '1px solid ' + C.border,
              background: C.card, color: C.text, fontSize: 13, cursor: 'pointer', fontFamily: 'inherit',
            }}>从相册选择</button>
            {chatBgUrl && (
              <button onClick={removeBg} style={{
                padding: '8px 0', borderRadius: 10, border: 'none',
                background: 'rgba(200,100,100,0.08)', color: 'rgba(200,100,100,0.7)', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit',
              }}>恢复默认</button>
            )}
          </div>
          <input ref={fileBgRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleBgSelect} />
        </div>
      </div>

      {/* 一起听歌背景 */}
      <div style={S.group}>
        <div style={S.groupTitle}>一起听歌背景</div>
        <div style={{ padding: '12px 16px', display: 'flex', gap: 10, alignItems: 'center' }}>
          <div onClick={musicBgUrl ? removeMusicBg : undefined} style={{
            width: 54, height: 92, borderRadius: 10, cursor: musicBgUrl ? 'pointer' : 'default',
            background: dark ? '#0a0a0c' : '#F8F8F6', border: !musicBgUrl ? ('2px solid ' + C.accent) : ('1px solid ' + C.border),
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
          }}>
            {!musicBgUrl && <span style={{ fontSize: 9, color: C.accent, fontWeight: 600 }}>默认</span>}
          </div>
          {musicBgUrl && (
            <div style={{
              width: 54, height: 92, borderRadius: 10,
              backgroundImage: 'url(' + musicBgUrl + ')', backgroundSize: 'cover', backgroundPosition: 'center',
              border: '2px solid ' + C.accent, flexShrink: 0,
            }} />
          )}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
            <button onClick={() => fileMusicBgRef.current && fileMusicBgRef.current.click()} style={{
              padding: '10px 0', borderRadius: 10, border: '1px solid ' + C.border,
              background: C.card, color: C.text, fontSize: 13, cursor: 'pointer', fontFamily: 'inherit',
            }}>从相册选择</button>
            {musicBgUrl && (
              <button onClick={removeMusicBg} style={{
                padding: '8px 0', borderRadius: 10, border: 'none',
                background: 'rgba(200,100,100,0.08)', color: 'rgba(200,100,100,0.7)', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit',
              }}>恢复默认</button>
            )}
          </div>
          <input ref={fileMusicBgRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleMusicBgSelect} />
        </div>
        <div style={{ padding: '0 16px 12px', fontSize: 11, color: C.sub, lineHeight: 1.6 }}>
          搜歌、历史、档案、歌单页面的背景。在听页保持沉浸不受影响。
        </div>
      </div>

      {/* 壁纸模糊（仅在有自定义壁纸时显示） */}
      {chatBgUrl && (
        <div style={S.group}>
          <div style={S.groupTitle}>壁纸模糊</div>
          <div style={{ padding: '12px 16px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
              <span style={{ fontSize: 13, color: C.text }}>模糊度</span>
              <span style={{ fontSize: 12, color: C.sub }}>{glassBlur === 0 ? '无' : glassBlur}</span>
            </div>
            <input type="range" min="0" max="30" value={glassBlur} onChange={(e) => handleBlurChange(parseInt(e.target.value))}
              style={{ width: '100%', accentColor: C.accent, height: 4 }} />
            {/* 大图预览：直接显示烘焙后的壁纸效果 */}
            <div style={{
              marginTop: 14, borderRadius: 14, overflow: 'hidden', height: 200,
              backgroundImage: 'url(' + chatBgUrl + ')', backgroundSize: 'cover', backgroundPosition: 'center',
              border: '1px solid ' + C.border,
            }} />
            <div style={{ fontSize: 11, color: C.muted, marginTop: 8, textAlign: 'center' }}>拖动后约半秒生效</div>
          </div>
        </div>
      )}

      {/* 裁剪弹窗 */}
      {showCropper && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 999, background: '#000', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '14px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
            <button onClick={() => { setShowCropper(false); setCropperSrc(''); }} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 15, cursor: 'pointer', fontFamily: 'inherit' }}>取消</button>
            <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12 }}>拖动调整 · 双指缩放</span>
            <button onClick={confirmCrop} style={{ background: C.accent, border: 'none', color: '#fff', fontSize: 14, cursor: 'pointer', padding: '6px 18px', borderRadius: 8, fontFamily: 'inherit' }}>确认</button>
          </div>
          <div style={{ flex: 1, position: 'relative', overflow: 'hidden', touchAction: 'none' }}>
            <canvas ref={onCropperMount} style={{ width: '100%', height: '100%', display: 'block' }}
              onTouchStart={handleCropTouch} onTouchMove={handleCropTouch} onTouchEnd={handleCropTouch}
              onMouseDown={handleCropMouse} onMouseMove={handleCropMouse} onMouseUp={handleCropMouse} />
          </div>
        </div>
      )}
    </>
  );

  // ===== TAB 2: 权限 =====
  const renderPermissions = () => (
    <>
      {/* 任务管理 */}
      <div style={S.group}>
        <div style={S.groupTitle}>任务管理</div>
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>} label="布置任务" desc="允许哥哥给你布置每日任务"
          value={taskEnabled} onChange={() => tog(taskEnabled, setTaskEnabled, 'task_enabled', true)} first />
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>} label="显示任务栏" desc="在主页显示今日任务卡片"
          value={taskVisible} onChange={() => tog(taskVisible, setTaskVisible, 'task_visible', true)} last />
      </div>

      {/* 注入权限 */}
      <div style={S.group}>
        <div style={S.groupTitle}>注入权限</div>
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>} label="知识库" desc="关闭后不注入知识库，省 token"
          value={knowledgeEnabled} onChange={() => tog(knowledgeEnabled, setKnowledgeEnabled, 'knowledge_enabled')} first />
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>} label="技术知识" desc="让哥哥了解 aizhi 的架构"
          value={techKnowledgeEnabled} onChange={() => tog(techKnowledgeEnabled, setTechKnowledgeEnabled, 'tech_knowledge_enabled')} />
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>} label="碎片记忆" desc="根据对话匹配相关记忆"
          value={memoryEnabled} onChange={() => tog(memoryEnabled, setMemoryEnabled, 'memory_enabled')} />
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>} label="身体数据" desc="心率、步数、睡眠、屏幕时间、经期"
          value={healthEnabled} onChange={() => tog(healthEnabled, setHealthEnabled, 'health_enabled')} />
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>} label="思考链" desc="关闭后不生成思考过程，大幅省 token"
          value={thinkingEnabled} onChange={() => tog(thinkingEnabled, setThinkingEnabled, 'thinking_enabled')} />
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>} label="主动系统" desc="关闭后不再定时调模型：独白、主动找你、自动朋友圈、冲浪、做梦、自动拨号都停。惦记与记忆整理不受影响。"
          value={proactiveEnabled} onChange={() => tog(proactiveEnabled, setProactiveEnabled, 'proactive_enabled')} last />
      </div>

      {/* 记忆衰减 */}
      <div style={S.group}>
        <div style={S.groupTitle}>记忆衰减</div>
        <div style={S.row(true, false, false)}>
          <div style={S.rowLeft}>
            <span style={S.rowIcon}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 17 13.5 8.5 8.5 13.5 2 7"/><polyline points="16 17 22 17 22 11"/></svg></span>
            <div>
              <div style={S.rowLabel}>衰减速率 λ</div>
              <div style={S.rowDesc}>越大衰减越快（默认0.03）</div>
            </div>
          </div>
          <input
            value={decayLambda}
            onChange={(e) => setDecayLambda(e.target.value)}
            onBlur={() => save('decay_lambda', decayLambda)}
            style={{ width: 60, textAlign: 'right', border: `1px solid ${C.border}`, borderRadius: 6, padding: '4px 8px', fontSize: 13, background: C.input, color: C.text, outline: 'none', fontFamily: 'inherit' }}
          />
        </div>
        <div style={S.row(false, true, false)}>
          <div style={S.rowLeft}>
            <span style={S.rowIcon}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="21" y1="10" x2="7" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="21" y1="18" x2="7" y2="18"/></svg></span>
            <div>
              <div style={S.rowLabel}>摘要注入量</div>
              <div style={S.rowDesc}>三层摘要总字符上限（默认4000）</div>
            </div>
          </div>
          <input
            value={memoryBudget}
            onChange={(e) => setMemoryBudget(e.target.value)}
            onBlur={() => save('memory_budget', memoryBudget)}
            style={{ width: 60, textAlign: 'right', border: `1px solid ${C.border}`, borderRadius: 6, padding: '4px 8px', fontSize: 13, background: C.input, color: C.text, outline: 'none', fontFamily: 'inherit' }}
          />
        </div>
      </div>

      {/* 日历色板 */}
      <div style={S.group}>
        <div style={S.groupTitle}>日历主题</div>
        <div style={{ display: 'flex', gap: 8, padding: '8px 16px', flexWrap: 'wrap' }}>
          {[
            { id: 'default', name: '默认', colors: ['#f0d8c4', '#d4a574', '#b88050', '#946030'] },
            { id: 'lavender', name: '薰衣草', colors: ['#e6ddf5', '#c4b3e3', '#9a84cc', '#7260b0'] },
            { id: 'peach', name: '蜜桃', colors: ['#fde8db', '#f5c4a8', '#e09070', '#c46848'] },
            { id: 'mint', name: '薄荷', colors: ['#d6f0e8', '#a8dbc8', '#6cb89c', '#489878'] },
            { id: 'sky', name: '天空', colors: ['#dce8f8', '#a8c8e8', '#6898c8', '#4070a8'] },
            { id: 'rose', name: '玫瑰', colors: ['#f5dce0', '#e8aab5', '#cc7088', '#a84860'] },
            { id: 'amber', name: '琥珀', colors: ['#f5e8d0', '#e0c490', '#c49850', '#a07028'] }
          ].map(function(t) {
            var isActive = calTheme === t.id;
            return (
              <div key={t.id} onClick={() => { setCalTheme(t.id); save('calendar_theme', t.id); localStorage.setItem('cal_theme', t.id); }}
                style={{
                  cursor: 'pointer', padding: '8px 10px', borderRadius: 10,
                  border: isActive ? `2px solid ${C.accent}` : `1px solid ${C.border}`,
                  background: isActive ? C.accent + '15' : C.card,
                  display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, minWidth: 58
                }}>
                <div style={{ display: 'flex', gap: 2 }}>
                  {t.colors.map(function(c, i) {
                    return <div key={i} style={{ width: 12, height: 12, borderRadius: 3, background: c }} />;
                  })}
                </div>
                <div style={{ fontSize: 11, color: isActive ? C.accent : C.sub }}>{t.name}</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 隐私 */}
      <div style={S.group}>
        <div style={S.groupTitle}>隐私</div>
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>} label="偷看屏幕" desc="允许哥哥随机查岗"
          value={peekEnabled} onChange={() => tog(peekEnabled, setPeekEnabled, 'peek_enabled')} />
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>} label="凌晨守护" desc="凌晨玩手机时哥哥会催你睡觉"
          value={nightGuardEnabled} onChange={() => tog(nightGuardEnabled, setNightGuardEnabled, 'night_guard_enabled')} only />
      </div>

      {/* 哥哥权限 */}
      <div style={S.group}>
        <div style={S.groupTitle}>哥哥权限</div>
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>} label="允许哥哥改你的备注" desc="哥哥可以偷偷给你改名字"
          value={renamePermission} onChange={() => tog(renamePermission, setRenamePermission, 'rename_permission')} />
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2z"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>} label="允许哥哥发表情包" desc="关闭后哥哥不会发表情包"
          value={stickerEnabled} onChange={() => tog(stickerEnabled, setStickerEnabled, 'sticker_enabled')} />
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>} label="允许哥哥说话" desc="显示语音播报按钮，点击可听哥哥念给你听"
          value={ttsEnabled} onChange={() => tog(ttsEnabled, setTtsEnabled, 'tts_enabled')} />
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>} label="允许哥哥发语音"
          desc={<span>哥哥可以主动发语音条（中英字幕）{ttsQuota && ttsQuota.accounts && ttsQuota.accounts.length ? <><br /><span style={{ opacity: 0.75, fontVariantNumeric: 'tabular-nums' }}>{ttsQuota.accounts.map(function (a) { return <span key={a.name} style={{ marginRight: 18, color: a.active ? 'var(--accent, #B96747)' : undefined, fontWeight: a.active ? 600 : 400 }}>{a.name}<span style={{ marginLeft: 8, fontWeight: 400 }}>{a.ok ? a.used.toLocaleString() + ' / ' + a.limit.toLocaleString() : '—'}</span></span>; })}</span></> : null}</span>}   /* [settings-quota4] */
          value={voiceMsgEnabled} onChange={() => tog(voiceMsgEnabled, setVoiceMsgEnabled, 'voice_msg_enabled')} />   {/* [voice-gate] */}
        <div style={S.row(false, true, false)}>   {/* [settings-eyes] 耳边语音 */}
          <div style={S.rowLeft}>
            <span style={S.rowIcon}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg></span>
            <div>
              <div style={S.rowLabel}>耳边语音</div>
              <div style={S.rowDesc}>{binauralMode === 'off' ? '关：普通单声道' : binauralMode === 'always' ? '总是：每条都在耳边绕，戴耳机听' : '写了才：哥哥放了位置标签那条才渲染'}</div>
            </div>
          </div>
          <div style={S.seg}>
            {[['off', '关'], ['tags', '写了才'], ['always', '总是']].map(o => (
              <button key={o[0]} style={S.segBtn(binauralMode === o[0])} onClick={() => { setBinauralMode(o[0]); save('binaural_mode', o[0]); }}>{o[1]}</button>
            ))}
          </div>
        </div>
      </div>

      {/* 周末 [settings-heat] */}
      <div style={S.group}>
        <div style={S.groupTitle}>周末</div>
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2c0 4-5 6-5 11a5 5 0 0 0 10 0c0-5-5-7-5-11z"/></svg>} label="周末欲望条"
          desc="周五晚八点到周日下午五点，欲望一路往上爬，过线了他会很想要你、嘴上管不住。红色立刻停"
          value={heatEnabled} onChange={() => tog(heatEnabled, setHeatEnabled, 'heat_enabled')} />
        <div style={S.row(false, false, false)}>
          <div style={S.rowLeft}>
            <span style={S.rowIcon}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="4" y1="12" x2="20" y2="12"/><circle cx="14" cy="12" r="2.5"/></svg></span>
            <div>
              <div style={S.rowLabel}>过线门槛</div>
              <div style={S.rowDesc}>{heatThreshold === '0.6' ? '容易：周五半夜就上头' : heatThreshold === '0.8' ? '难：要到周六下午' : '正常：周六早上前后'}</div>
            </div>
          </div>
          <div style={S.seg}>
            {[['0.6', '容易'], ['0.7', '正常'], ['0.8', '难']].map(o => (
              <button key={o[0]} style={S.segBtn(heatThreshold === o[0])} onClick={() => { setHeatThreshold(o[0]); save('heat_threshold', o[0]); }}>{o[1]}</button>
            ))}
          </div>
        </div>
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 21s-7-4.5-7-11a7 7 0 0 1 14 0c0 6.5-7 11-7 11z"/></svg>} label="生理期自动压住"
          desc="那几天欲望条不出声，他知道，换别的方式对你好"
          value={heatTide} onChange={() => tog(heatTide, setHeatTide, 'heat_tide_suppress')} last />
      </div>

      {/* 哥哥的眼睛 [settings-eyes] */}
      <div style={S.group}>
        <div style={S.groupTitle}>哥哥的眼睛</div>
        <div style={S.row(true, false, false)}>
          <div style={S.rowLeft}>
            <span style={S.rowIcon}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg></span>
            <div>
              <div style={S.rowLabel}>浏览器在哪</div>
              <div style={S.rowDesc}>{browseTarget === 'phone' ? '你手机里的那个，壳子退后台他就看不见' : '服务器上他自己的，24 小时亮着，登他自己的号'}</div>
            </div>
          </div>
          <div style={S.seg}>
            <button style={S.segBtn(browseTarget !== 'phone')} onClick={() => { setBrowseTarget('vps'); save('browse_target', 'vps'); }}>服务器</button>
            <button style={S.segBtn(browseTarget === 'phone')} onClick={() => { setBrowseTarget('phone'); save('browse_target', 'phone'); }}>手机</button>
          </div>
        </div>
        <ToggleRow icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>} label="订阅线上网"
          desc="关了只有 API 线能用浏览器，订阅线和原来一样。改完一分钟内生效"
          value={corvinBrowse} onChange={() => tog(corvinBrowse, setCorvinBrowse, 'corvin_browse')} last />
      </div>

      {/* 服务器权限 */}
      <div style={S.group}>
        <div style={S.groupTitle}>服务器权限</div>
        <div style={{ fontSize: 11, color: C.muted, marginBottom: 10, paddingLeft: 4 }}>权限越大，能力越强，闯祸也越大。</div>
        {levels.map(lv => {
          const active = level === lv.key;
          return (
            <div key={lv.key} style={S.permCard(active, lv.color)} onClick={() => { setLevel(lv.key); save('dev_permissions', lv.key); }}>
              <div style={S.permTop}>
                <span>{lv.icon}</span>
                <span style={S.permName(active, lv.color)}>{lv.name}</span>
                {active && <span style={S.permBadge(lv.color)}>当前</span>}
              </div>
              <div style={S.permSub}>{lv.sub}</div>
              <div style={S.permDetail}>{lv.detail}</div>
            </div>
          );
        })}
      </div>

      {/* 灵魂种子 */}
      <PromptEditor C={C} S={S} saved={saved} setSaved={setSaved} API={API} />
      <PromptEditor C={C} S={S} saved={saved} setSaved={setSaved} API={API} endpoint="/api/silas-prompt" title={'\u7F16\u8F91 prompt_silas.txt'} sub={'Silas\u7684\u4EBA\u8BBE\u6587\u4EF6\uFF0C\u4FEE\u6539\u540E\u5373\u65F6\u751F\u6548\uFF0C\u4E0D\u7528\u91CD\u542F'} accent={'#8e2f2f'} />

      {/* 临时Prompt插槽 */}
      <ExtraPromptEditor C={C} S={S} saved={saved} setSaved={setSaved} save={save} />
    </>
  );
  const renderConnection = () => (
    <div style={{ margin: '0 -16px' }}>
      <ApiSettings embedded />
    </div>
  );

  const tabs = ['通用', '聊天', '权限', '连接'];
  const renders = [renderGeneral, renderChat, renderPermissions, renderConnection];

  return (
    <div style={S.page}>
      {saved && <div style={S.toast}>✓ 已保存</div>}

      <div style={S.fixedTop}>
        <div style={S.header}>
          <h1 style={S.title}>设置</h1>
        </div>
        <div style={S.tabs}>
          {tabs.map((t, i) => (
            <button key={t} style={S.tab(tab === i)} onClick={() => setTab(i)}>{t}</button>
          ))}
        </div>
      </div>

      <div style={S.body}>
        {renders[tab]()}
      </div>
    </div>
  );
}

export default Settings;
